import { Button, CircularProgress, Typography } from '@mui/material'
import React from 'react'
import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded'
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import ModeEditOutlineRoundedIcon from '@mui/icons-material/ModeEditOutlineRounded'
import { getSecureImage } from '../../../api/hds'
import { documentExt, pictureExt } from '../../../api/media'
import useStyles from './_styles'

const PlannedConsultationEditorFormMedia = ({ media, onPreview, onRenameRequest, onDeleteRequest }: any) => {
    const classes = useStyles()
    const [backgroundImage, setBackgroundImage] = React.useState('')
    const [isDownloading, setIsDownloading] = React.useState(false)

    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
        id: media.id,
    })

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    }

    React.useEffect(() => {
        const init = async () => {
            if (pictureExt.includes(media.ext)) {
                setIsDownloading(true)
                const image = await getSecureImage(media.url)
                // @ts-expect-error TS(2339) FIXME: Property 'localUrl' does not exist on type 'void |... Remove this comment to see the full error message
                setBackgroundImage(image.localUrl)
                setIsDownloading(false)
            }
        }
        init()
    }, [])

    const handleOnPreview = () => {
        const type = documentExt.includes(media.ext) ? 'document' : 'picture'
        onPreview(media, type)
    }

    const renderMediaThumb = () => (
        <div
            className={classes.PlannedConsultationEditorFormMediaThumbnail}
            style={{
                backgroundImage: `url(${backgroundImage})`,
            }}
        >
            {documentExt.includes(media.ext) && (
                <div className={classes.PlannedConsultationEditorFormMediaThumbnailPdf}>
                    <Typography className={classes.PlannedConsultationEditorFormMediaThumbnailPdfText}>PDF</Typography>
                </div>
            )}
        </div>
    )

    return (
        <div className={classes.PlannedConsultationEditorFormMedia} ref={setNodeRef} style={style}>
            <div className={classes.PlannedConsultationEditorFormMediaCard}>
                <Button
                    className={classes.PlannedConsultationEditorFormMediaThumbnailContainer}
                    onClick={handleOnPreview}
                    onKeyUp={handleOnPreview}
                    {...attributes}
                    {...listeners}
                >
                    {isDownloading ? <CircularProgress /> : renderMediaThumb()}
                </Button>
                <div className={classes.PlannedConsultationEditorFormMediaBanner}>
                    <Button
                        className={classes.PlannedConsultationEditorFormMediaBannerButton}
                        onClick={() => onRenameRequest(media)}
                    >
                        <ModeEditOutlineRoundedIcon />
                    </Button>
                    <Button
                        className={classes.PlannedConsultationEditorFormMediaBannerButton}
                        onClick={handleOnPreview}
                    >
                        <RemoveRedEyeRoundedIcon />
                    </Button>
                    <Button className={classes.PlannedConsultationEditorFormMediaBannerButton}>
                        <DeleteRoundedIcon onClick={() => onDeleteRequest(media)} />
                    </Button>
                </div>
            </div>
            <Typography className={classes.PlannedConsultationEditorFormMediaName}>{media.name}</Typography>
        </div>
    )
}

export default PlannedConsultationEditorFormMedia
